export enum UserStatus
{
    CONFIRMED = "CONFIRMED",
    FORCE_CHANGE_PASSWORD="FORCE_CHANGE_PASSWORD"
}